import { Trans, useLingui } from "@lingui/react/macro"

// Shared header for the post-call card's sub-views (More,
// Link a deal, New deal). Title (with optional context
// subtitle below it) on the left; the "‹ Back" affordance on
// the TOP RIGHT — a back chevron, never a close (✕) that reads
// as "discard the whole card". Consistent across every
// sub-view so back-navigation always sits in the same place.
export function AfterCallSubviewHeader({
  title,
  subtitle,
  onBack,
}: {
  title: string
  subtitle?: string
  onBack: () => void
}) {
  const { t } = useLingui()
  return (
    <div className="flex items-start gap-3">
      <div className="flex min-w-0 grow flex-col gap-0.5">
        <span className="text-[15px] font-semibold leading-tight text-[#FBF7F0]">
          {title}
        </span>
        {subtitle ? (
          <span className="truncate text-xs text-[#9A938A]">{subtitle}</span>
        ) : null}
      </div>
      <button
        type="button"
        onClick={onBack}
        aria-label={t`Back`}
        data-testid="after-call-subview-back"
        className="flex shrink-0 items-center gap-0.5 text-[13px] font-medium text-[#E0A56A] hover:underline"
      >
        <Trans>‹ Back</Trans>
      </button>
    </div>
  )
}
